import { store } from './store';
import { isSuperUser } from './userRoles';

export const PERMISSIONS = Object.freeze({
  ALERTS: 'alerts/access',
  ANALYTICS: 'analytics/access',

  BILLING_TASKS: 'billing/tasks',
  BILLING_TASK_DETAILS: 'billing/task_details',
  BILLING_DEVICE_EVENTS: 'billing/device_events',
  BILLING_DEVICE_INVOICES: 'billing/device_invoices',

  MESSAGES_ARCHIVED: 'messages/archived',
  MESSAGES_INBOX: 'messages/inbox',
  MESSAGES_PREFABS: 'messages/prefabs',
  MESSAGES_DEFAULT_REMINDERS_VIEW: 'messages/default_reminders_view',
  MESSAGES_DEFAULT_REMINDERS_EDIT: 'messages/default_reminders_edit',
  MESSAGES_SEND_MESSAGES: 'messages/send_messages',

  CARE_MANAGEMENT_DASHBOARD_PROGRAMS: 'care_management/dashboard_programs',
  CARE_MANAGEMENT_PATIENT_DASHBOARD: 'care_management/patient_dashboard', // brakuje
  CARE_MANAGEMENT_PATIENT_INFO: 'care_management/patient_info',
  CARE_MANAGEMENT_PATIENT_INFO_EDIT: 'care_management/patient_info_edit',
  CARE_MANAGEMENT_PATIENT_LIST: 'care_management/patient_list',
  CARE_MANAGEMENT_PATIENT_READINGS: 'care_management/patient_readings',
  CARE_MANAGEMENT_PATIENT_DEVICES: 'care_management/patient_devices',
  CARE_MANAGEMENT_PATIENT_DEVICES_EDIT: 'care_management/patient_devices_edit',
  CARE_MANAGEMENT_PATIENT_MEDICATIONS: 'care_management/patient_medications',
  CARE_MANAGEMENT_PATIENT_MEDICATION_EDIT: 'care_management/patient_medication_edit',
  CARE_MANAGEMENT_PATIENT_TASK_HISTORY: 'care_management/patient_task_history',
  CARE_MANAGEMENT_PATIENT_DEVICE_DETAILS: 'care_management/patient_device_details',
  CARE_MANAGEMENT_PATIENT_OVERLAY_PLOTS: 'care_management/patient_overlay_plots',
  CARE_MANAGEMENT_PATIENT_LOG: 'care_management/patient_log',
  CARE_MANAGEMENT_PATIENT_BILLABLE_TIME: 'care_management/patient_billable_time',
  CARE_MANAGEMENT_PATIENT_ALERT_TRESHOLDS: 'care_management/patient_alerts_thresholds',
  CARE_MANAGEMENT_PATIENT_VITAL_GOALS: 'care_management/patient_vital_goals',
  CARE_MANAGEMENT_PATIENT_GRAPH_ANNOTATIONS_VIEW: 'care_management/patient_graph_annotations_view',
  CARE_MANAGEMENT_PATIENT_GRAPH_ANNOTATIONS_EDIT: 'care_management/patient_graph_annotations_edit',
  CARE_MANAGEMENT_PATIENT_DEVICES_MEDS_COUNT: 'care_management/patient_devices_meds_count',
  CARE_MANAGEMENT_PATIENT_DOCUMENTS: 'care_management/patient_documents',
  CARE_MANAGEMENT_TASK_TIMER: 'care_management/task_timer',
  CARE_MANAGEMENT_UPLOAD_PATIENT_LIST: 'care_management/upload-patient-list',
  CARE_MANAGEMENT_PATIENT_DOWNLOAD_VITALS_CSV: 'care_management/patient_download_vitals_csv',
  CARE_MANAGEMENT_PATIENT_ENROLL: 'care_management/patient_enroll',
  CARE_MANAGEMENT_PATIENT_PROGRAM_ACTIVATION: 'care_management/patient_program_activation',
  CARE_MANAGEMENT_PATIENT_PAGES_HEALTH_CENTER: 'care_management/patient_pages_health_center',
  CARE_MANAGEMENT_PATIENT_PAGES_MEDICATIONS: 'care_management/patient_pages_medications',
  CARE_MANAGEMENT_PATIENT_PAGES_DEVICES: 'care_management/patient_pages_devices',
  CARE_MANAGEMENT_CARE_PROVIDER_ROLE: 'care_management/care_provider_role',

  LEGACY_PATIENTS_ACTIVE: 'legacy/patients_active',
  LEGACY_PATIENTS_PENDING: 'legacy/patients_pending',
  LEGACY_PATIENTS_TERMED: 'legacy/patients_termed',
  LEGACY_DOCTOR_DASHBOARD_ADHERENCE_CHART: 'legacy/doctor_dashboard_adherence_chart',
  LEGACY_DOCTOR_DASHBOARD_ADHERENCE_STATS: 'legacy/doctor_dashboard_adherence_stats',
  LEGACY_DOCTOR_DASHBOARD_CAP_EVOLUTION: 'legacy/doctor_dashboard_cap_evolution',
  LEGACY_PATIENT_PAGES_DASHBOARD: 'legacy/patient_pages_dashboard',
  LEGACY_PATIENT_PAGES_CALENDAR: 'legacy/patient_pages_calendar',
  LEGACY_PATIENT_PAGES_HISTORY: 'legacy/patient_pages_history',
  LEGACY_PATIENT_PAGES_MEDICATIONS: 'legacy/patient_pages_medications',

  CONTACT_DETAILS_CHAT: 'contact_details/chat',
  CONTACT_DETAILS_EMAIL: 'contact_details/email',
  CONTACT_DETAILS_SMART_CAP: 'contact_details/smart_cap',
  CONTACT_DETAILS_DOCUMENTS: 'contact_details/documents',
  CONTACT_DETAILS_RPM_VIDEO: 'contact_details/rpm_video',
  CONTACT_DETAILS_EXTERNAL_SPEC: 'contact_details/external_spec',
  CONTACT_DETAILS_LOCATION: 'contact_details/location',

  DEVICES_BLE: 'devices/device_types/ble',
  DEVICES_HUB: 'devices/device_types/hub',
  DEVICES_LTE: 'devices/device_types/lte',
  DEVICES_LSC: 'devices/device_types/lsc',
  DEVICES_INJECTABLE_TRACKER: 'devices/device_types/injectable_tracker',
  DEVICES_MDP: 'devices/device_types/mdp',
  DEVICES_LTE_MEDICATION_ORGANIZER: 'devices/device_types/lte_medication_organizer',
  DEVICES_BPM: 'devices/device_types/bpm',
  DEVICES_WEIGHTING_MACHINE: 'devices/device_types/wm',
  DEVICES_WB: 'devices/device_types/wb',
  DEVICES_GLUCO: 'devices/device_types/glucometer',
  DEVICES_THERMOMETER: 'devices/device_types/thermometer',
  DEVICES_INHALER: 'devices/device_types/inhaler',
  DEVICES_SPIROMETER: 'devices/device_types/spirometer',
  DEVICES_PULSEOX: 'devices/device_types/pulseox',
  DEVICES_ATMOCUBE: 'devices/device_types/atmocube',
  DEVICES_ATMOTUBE: 'devices/device_types/atmotube',
  DEVICES_HAILIE_INHALER: 'devices/device_types/hailie_inhaler',
  DEVICES_DEXCOM_CGM: 'devices/device_types/dexcom_cgm',
  DEVICES_PTINR_MONITOR: 'devices/device_types/ptinr_monitor',
  DEVICES_DASHBOARD: 'devices/devices_dashboard',
  DEVICES_SHOW_DELETED: 'devices/show_deleted',
  DEVICES_KITS_MANAGEMENT: 'devices/kits_management',
  DEVICES_KITS_SHOW_PATIENT: 'devices/kits_show_patient',
  DEVICES_PROVISIONING: 'devices/provisioning',

  ORGANIZATION_ADMIN_VIEW: 'organization/admin_view',
  ORGANIZATION_ADMIN_EDIT: 'organization/admin_edit',
  ORGANIZATION_CAPMANAGER_VIEW: 'organization/cap_manager_view',
  ORGANIZATION_CAPMANAGER_EDIT: 'organization/cap_manager_edit',
  ORGANIZATION_ORG_MANAGER_VIEW: 'organization/org_manager_view',
  ORGANIZATION_ORG_MANAGER_EDIT: 'organization/org_manager_edit',
  ORGANIZATION_MANAGEMENT: 'organization/organization_management',
  ORGANIZATION_ADMIN: 'organization/organization_admin',
  ORGANIZATION_OUTBOUND_API: 'organization/outbound_api',
  ORGANIZATION_GROUPING: 'organization/grouping',
  ORGANIZATION_PROVIDER_VIEW: 'organization/provider_view',
  ORGANIZATION_PROVIDER_EDIT: 'organization/provider_edit',
  ORGANIZATION_PROVIDER_REASSIGN: 'organization/provider_reassign',
  ORGANIZATION_CARE_PROVIDER_API: 'organization/care_provider_api',
  ORGANIZATION_EXTERNAL_API_ACCESS_CONTROL: 'organization/external_api_access_control',
  ORGANIZATION_EXTERNAL_API_LOGS: 'organization/external_api_logs',
  ORGANIZATION_EXTERNAL_API_OAUTH: 'organization/external_api_oauth',

  SHIPPING_SHIPMENTS_VIEW: 'shipping/shipments_view',
  SHIPPING_SHIPMENTS_EDIT: 'shipping/shipments_edit',
  SHIPPING_ORDERS_VIEW: 'shipping/orders_view',
  SHIPPING_ORDERS_EDIT: 'shipping/orders_edit',

  SHIPPING_PATIENTS_WITHOUT_KIT_VIEW: 'shipping/patients_without_kit_view',
  SHIPPING_PATIENTS_WITHOUT_KIT_EDIT: 'shipping/patients_without_kit_edit',
  SHIPPING_SHIPPED_DEVICES: 'shipping/shipped_devices',
  SHIPPING_INVENTORY: 'shipping/inventory',
  SHIPPING_SMART_ORDERING_EDIT: 'shipping/smart_ordering_catalog_edit',
  SHIPPING_SMART_ORDERING_VIEW: 'shipping/smart_ordering_catalog_view',
  SHIPPING_PENDING_REVIEW_ORDERS_EDIT: 'shipping/pending_review_orders_edit',
  SHIPPING_PENDING_REVIEW_ORDERS_VIEW: 'shipping/pending_review_orders_view',
  SHIPPING_PENDING_RETURNS_VIEW: 'shipping/pending_returns_view',
  SHIPPING_PENDING_RETURNS_EDIT: 'shipping/pending_returns_edit',
  SHIPPING_BULK_PENDING_RETURNS_VIEW: 'shipping/bulk_pending_returns_view',
  SHIPPING_BULK_PENDING_RETURNS_EDIT: 'shipping/bulk_pending_returns_edit',

  REPORT: 'report/access',
  WORKFLOW_ENROLLMENT: 'workflow_enrollment', // TO BE DEPRECATED
});

export const PERMISSION_GROUPS = Object.freeze({
  BILLING: 'billing/',
  MESSAGES: 'messages/',
  DEVICES: 'devices/',
  CARE_MANAGEMENT: 'care_management/',
  LEGACY_PATIENTS: 'legacy/patients_',
  LEGACY_DOCTOR_DASHBOARD: 'legacy/doctor_dashboard_',
  CONTACT_DETAILS: 'contact_details/',
  ORGANIZATION: 'organization/',
  SHIPPING: 'shipping/',
  // PROVISIONING: 'provisioning/',
  // STUDY: 'study/',
});

export function getPermissions() {
  const ret = store.getState().auth.permissions;
  return ret;
}

export function hasPermission(permission) {
  return getPermissions()?.find(p => p === permission) !== undefined;
}

export function hasAnyPermissionInGroup(permissionGroup) {
  return getPermissions()?.find(p => p.startsWith(permissionGroup)) !== undefined;
}

export const ORG_FEATURES = {
  merged_onboard_modals: "care_management/merged_onboard_modals",
  transplant_details_enabled: "care_management/transplant_details_enabled",
  select_vitals_during_enrollment: "care_management/select_vitals_during_enrollment",
  select_vitals_during_activation: "care_management/select_vitals_during_activation",
  supported_subprograms: "care_management/supported_subprograms",
  patient_portal_access: "care_management/patient_portal_access",
  enrollment_activation_modes: "care_management/enrollment_activation_modes",
  use_outreach_status: "feature_flags/use_outreach_status",
  hide_cohorts: "feature_flags/hide_cohorts",
  shipper_enabled: "shipping/shipper_enabled",
  shipping_assigns_kit_to_enrollment: "shipping/shipment_assigns_kit_to_enrollment",
  shipping_smart_ordering: "shipping/smart_ordering_enabled",
  shipping_smartmeter_fulfillment_enabled: "shipping/smartmeter_fulfillment_enabled",
  eula: "general/eula_required",
  engagement_messages_enabled: "messages/engagement_messages_enabled",
  time_milestone_messages_enabled: "messages/time_milestone_messages_enabled",
  inovalon_enabled: "inovalon/module_enabled",
  inovalon_eligibility_cooldown_hours: "inovalon/eligibility_cooldown_hours",
  theme: "preferences/theme",
  timezone: "preferences/timezone",
  units: "preferences/units",
  athena_enabled: "athena/module_enabled",
  surveys_enabled: "surveys/module_enabled",
};

function getOrgFeatures() {
  const ret = store.getState().auth?.org_config;
  return ret;
}

export function orgFeatureEnabled(feature) {
  const module = feature.split('/')[0];
  const moduleFeature = feature.split('/')[1];
  const features = getOrgFeatures();
  return features?.[module] && features?.[module]?.[moduleFeature] !== false;
}

export function orgFeatureValue(feature) {
  const module = feature.split('/')[0];
  const moduleFeature = feature.split('/')[1];
  const features = getOrgFeatures();
  return features?.[module]?.[moduleFeature];
}

// Negative flag: an org_config without the key keeps cohorts visible.
export function canViewCohorts() {
  return isSuperUser() || orgFeatureValue(ORG_FEATURES.hide_cohorts) !== true;
}
